<div mat-dialog-content class="flex flex-column">
    <div class="flex flex-1 flex-column flex-center full-height" *ngIf="loadingDocuments">
        <h1 style="margin-bottom: 2rem;">Loading Documents</h1>
        <mat-spinner diameter="48"></mat-spinner>
    </div>
    <iframe *ngIf="!loadingDocuments" id="docusignFrame"  title="Docusign" style="height: auto; display: none;" [src]="url"></iframe>
</div>
